<template>
  <div ref="searchBox" class="search-box">
    <div class="input-group input-group-outline mb-3 has-validation" 
    :class="{ 'focused is-focused': focused, 'my-input-disabled': isBlocked === true }">
      <label class="form-label">{{ label }}</label>
      <i class="fas fa-user-plus search-input-icon" @click="toggleSuggestions"></i>
      <div class="badge-container form-control">
        <template v-if="valuesItems.length">
          <span v-for="(item, index) in valuesItems" :key="item.id" @click="removeSelectedItem(index)"
            :title="item.name">
            <app-avatar-admin :name="item.name" class="avatar-mini" />
          </span>
        </template>
      </div>

      <ul v-if="showItems" class="list-group">
        <li class="list-group-item" v-for="item in filteredItems" :key="item.id" @click="setItem(item)">{{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AppAvatarAdmin from "@/components/AppAvatarAdmin/AppAvatarAdmin.vue";
import { mapActions } from "vuex";

export default {
  props: {
    id: { type: [String, Number], default: null },
    label: { type: String, required: false, default: "" },
    items: { type: [String, Array], required: true, default: () => [] },
    defaultValue: { type: [Object, Array, String], default: () => [] },
    tagCss: { type: [String, Number], default: "1" },
    addNewValue: { type: Number, default: 0 },
    userAdmin: { type: [Number, String], required: false }
  },
  components: {
    AppAvatarAdmin
  },
  data() {
    return {
      focused: false,
      valuesItems: [],
      showItems: false
    };
  },
  created() {
    this.formatCustomData();
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  computed: {
    isBlocked() {
      if (this.userAdmin != null && this.userAdmin != 1) {
        return true;
      }
      return false;
    },
    filteredItems() {
      return this.items.filter(
        item => !this.valuesItems.some(selected => selected.id === item.id)
      );
    }
  },
  methods: {
    ...mapActions(["showMessage"]),
    formatCustomData() {
      if (typeof this.defaultValue === "string") {
        try {
          this.valuesItems = JSON.parse(this.defaultValue);
        } catch (error) {
          console.error("Erro ao parsear defaultValue:", error);
          this.valuesItems = [];
        }
      } else if (Array.isArray(this.defaultValue)) {
        this.valuesItems = this.defaultValue;
      } else {
        this.valuesItems = [];
      }
    },
    toggleSuggestions() {
      this.showItems = !this.showItems;
    },
    handleClickOutside(event) {
      const isClickInside = this.$refs.searchBox.contains(event.target);

      if (!isClickInside) {
        this.showItems = false;
      }
    },
    setItem(item) {
      if (!this.valuesItems.find(d => d.id === item.id)) {
        this.valuesItems.push({
          id: item.id,
          name: item.name,
          email: item.email
        });
        this.showItems = false;
        this.$emit("input", this.valuesItems, this.id);
      }
    },
    removeSelectedItem(index) {
      if (this.isBlocked != true) {
        this.valuesItems.splice(index, 1);
        this.$emit("input", this.valuesItems, this.id);
      }

    }
  }
};
</script>

<style scoped>
.search-box {
  position: relative;
  float: left;
  width: 100%;
}

.badge-container {
  display: inline-block;
  padding-bottom: 0 !important;
  min-height: 42px;
}

.list-group {
  position: absolute;
  left: 0;
  right: 0;
  top: 40px;
  height: auto;
  max-height: 300px;
  overflow: auto;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  border: 2px solid #ddd !important;
  background: none;
  border-top: none;
  list-style: none;
  z-index: 9999;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  height: auto;
  background: #f8f9fa;
  border-top: 1px solid #fff;
  color: #8687a4;
}

.list-group-item:hover {
  background: white !important;
  color: #3b5de7 !important;
  cursor: pointer;
}

.search-input-icon {
  position: absolute;
  float: left;
  left: 12px;
  top: 16px;
  z-index: 3;
  font-size: 16px;
  color: #ccc;
}

.form-control {
  padding-left: 40px;
}

.my-badge {
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 5px;
  display: inline-block;
  padding: 4px 6px;
  line-height: 1;
  max-width: 100%;
  text-wrap: nowrap;
  overflow: hidden;
}

.clear-button {
  padding: 0px;
  font-size: 14px;
  line-height: 14px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
</style>